import { vservice } from '@niknevis/vue-modules'
import { MediaRoute } from '@/modules/media/routes/media.route'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'

@vservice()
export class MediaService {
  constructor(
    private readonly routes: MediaRoute
  ) {
  }

  showMedia(mediaId: number) {
    return HTTP.get(
      this.routes.show(mediaId)
    ).then(response => response.json())
  }

  deleteMedia(mediaId: number) {
    return HTTP.delete(
      this.routes.delete(mediaId)
    ).then(response => response.json())
  }
}
